import KeyValueListDisplay from '@/components/KeyValueDisplay';
import type { CommonDetails, DeliveryDetailDeliveryInformation } from '@/types/deliveryDetail.types';
import { convertISODateToMMDDYYYY, convertISOToTime } from '@/lib/utils';

export const DeliveryInformationContent = ({
  data,
  commonDetails,
}: {
  data: DeliveryDetailDeliveryInformation | undefined;
  commonDetails: CommonDetails | undefined;
}) => {
  if (!data) return null;

  const deliveryDetails = [
    { label: "Person/Entity's Name", value: data.deliveryName },
    { label: 'Phone Number', value: data.deliveryPhone ?? '-' },
    { label: 'Attention', value: data.attention ?? '-' },
    { label: 'Address', value: data.deliveryAddress },
    {
      label: 'Delivery Date and Time',
      value: `${convertISODateToMMDDYYYY(data.deliveryDateTime)} ${convertISOToTime(data.deliveryDateTime)}`,
    },
    { label: "Delivery Instructions", value: data.deliveryInstructions ?? '-' },
    { label: 'Assigned Delivery Driver', value: data.deliveryDriverName ?? '-' },
    { label: "Driver's Phone Number", value: data.deliveryDriverPhone ?? '-' },
    { label: 'Return Date', value: data.returnDate ? convertISODateToMMDDYYYY(data.returnDate) : '-' },
    { label: 'DGR Check', value: commonDetails?.dgrCheck ? 'Yes' : 'No' },
    ...(commonDetails?.dgrCheck
      ? [
          { label: 'Check Number', value: commonDetails.checkNumber ?? '-' },
          { label: 'Check Amount', value: commonDetails.checkAmount != null ? `$${commonDetails.checkAmount.toFixed(2)}` : '-' },
        ]
      : []),
  ];

  return (
    <div className="flex flex-col gap-4 w-full px-6 py-4">
      <div className="flex flex-col gap-2 w-full text-sm">
        <KeyValueListDisplay data={deliveryDetails} />
      </div>
    </div>
  );
};
